<ng-template
  [ngIf]="stats.totalCameras"
  [ngIfThen]="camerasCountSetTml"
  [ngIfElse]="emptySetTml"
></ng-template>

<ng-template #camerasCountSetTml>
  <mat-chip-list (outlined)="(outlined)">
    <mat-chip
      *ngIf="stats.countUpCameras || displayZeroCounts"
      class="chipUpCamera"
      [matTooltip]="'common.up' | t"
      (size)="(size)"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(CAMERAS_STATUS.Up)"
      color="accent"
      selected
    >
      <div class="chipUpInfo">
        <span *ngIf="displayLabels">{{ 'common.up' | t }}: </span>
        <span>{{ stats.countUpCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countDownCameras || displayZeroCounts"
      class="chipDownCamera"
      [matTooltip]="'common.down' | t"
      size="size"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(CAMERAS_STATUS.Down)"
      color="warn"
      selected
    >
      <div class="chipDownInfo">
        <span *ngIf="displayLabels">{{ 'common.down' | t }}: </span>
        <span>{{ stats.countDownCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countPendingCameras || displayZeroCounts"
      class="chipWarningCamera"
      [matTooltip]="'common.pending' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(CAMERAS_STATUS.Pending)"
    >
      <div class="chipWarningInfo">
        <span *ngIf="displayLabels">{{ 'common.pending' | t }}: </span>
        <span>{{ stats.countPendingCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countUnmanagedCameras || displayZeroCounts"
      class="chipUnmanagedCamera"
      [matTooltip]="'common.unmanaged' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(CAMERAS_STATUS.Unmanaged)"
      color="primary"
      selected
    >
      <div class="chipUnmanagedInfo">
        <span *ngIf="displayLabels">{{ 'common.unmanaged' | t }}: </span>
        <span>{{ stats.countUnmanagedCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countUnconfiguredCameras || displayZeroCounts"
      class="chipUnconfiguredCamera"
      [matTooltip]="'common.unconfigured' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(CAMERAS_STATUS.Unconfigured)"
    >
      <div class="chipUnconfiguredInfo">
        <span *ngIf="displayLabels">{{ 'common.unconfigured' | t }}: </span>
        <span>{{ stats.countUnconfiguredCameras | fsNumber }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-template>

<ng-template #emptySetTml>
  <span class="empty">{{ 'common.noCameras' | t }}</span>
</ng-template>
